
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import DocsLayout from '../../components/DocsLayout'
import NextPage from '../../components/NextPage'
import BabelPlugin from '../../sections/tooling/babel-plugin.md'
import BabelMacro from '../../sections/tooling/babel-macro.md'
import TypeScriptPlugin from '../../sections/tooling/typescript-plugin.md'
import Jest from '../../sections/tooling/jest.md'
import Stylelint from '../../sections/tooling/stylelint.md'
import StyledTheming from '../../sections/tooling/styled-theming.md'
import SyntaxHighlighting from '../../sections/tooling/syntax-highlighting.md'


const layoutProps = {
  
};
const MDXLayout = ({ children }) => (
  <DocsLayout
    title="Tooling"
    description="Additional Tools for styled-components, babel and TypeScript plugins, testing"
  >
    {children}
  </DocsLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <BabelPlugin mdxType="BabelPlugin" />
    <BabelMacro mdxType="BabelMacro" />
    <TypeScriptPlugin mdxType="TypeScriptPlugin" />
    <Jest mdxType="Jest" />
    <Stylelint mdxType="Stylelint" />
    <StyledTheming mdxType="StyledTheming" />
    <SyntaxHighlighting mdxType="SyntaxHighlighting" />
    <NextPage href="/docs/faqs" title="FAQs" mdxType="NextPage" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;